<div class="row shadow p-4 mb-5 bg-white rounded mt-3 monitor-dashboard-chart-card">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <h5 class="mb-2 monitor-dashboard-card-title">
        <span class="monitor-dashboard-chart-title-link" @click="onTitleClick">{{$t('monitorDashboard.complaintFrequencyPerSender')}}</span>
      </h5>
    </div>

    <div class="monitor-dashboard-chart-stage monitor-dashboard-frequency-chart-stage">
      <div v-show="!isLoading && hasData" class="monitor-dashboard-frequency-chart-body">
        <div class="monitor-dashboard-frequency-per-sender-scroll" role="region"
          tabindex="0"
          :aria-label="$t('monitorDashboard.complaintFrequencyPerSender')">
          <div class="monitor-dashboard-frequency-per-sender-inner" :style="chartHostStyle">
            <canvas :id="canvasId" class="monitor-dashboard-chart-canvas monitor-dashboard-frequency-chart-canvas" role="img"
              :aria-label="$t('monitorDashboard.complaintFrequencyPerSender')"></canvas>
          </div>
        </div>
      </div>

      <div v-if="isLoading" class="monitor-dashboard-skeleton-wrap" role="status" aria-live="polite">
        <span class="sr-only">{{$t('monitorDashboard.loading')}}</span>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-block" aria-hidden="true"></div>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line" aria-hidden="true"></div>
        <div class="monitor-dashboard-skeleton monitor-dashboard-skeleton-line monitor-dashboard-skeleton-line--short"
          aria-hidden="true"></div>
      </div>

      <div v-else-if="!hasData" class="monitor-dashboard-state-block">
        <p class="mb-0 font-weight-bold">{{ $t('monitorDashboard.noDataAvailable') }}</p>
      </div>
    </div>
  </div>
</div>
